var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 10.1667L10.6 11.3889L13 8.94444M7 8.33333H4.6C3.48174 8.33333 2.92261 8.33333 2.48156 8.51941C1.89349 8.7675 1.42627 9.24337 1.18269 9.84233C1 10.2915 1 10.861 1 12M9.1 1.17769C9.97955 1.54031 10.6 2.41858 10.6 3.44444C10.6 4.47031 9.97955 5.34858 9.1 5.7112M7.9 3.44444C7.9 4.79447 6.82548 5.88889 5.5 5.88889C4.17452 5.88889 3.1 4.79447 3.1 3.44444C3.1 2.09441 4.17452 1 5.5 1C6.82548 1 7.9 2.09441 7.9 3.44444Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfEvaluation);
export default __webpack_public_path__ + "static/media/self-evaluation.2ff463db33ebb3c8321eb5650ce1e088.svg";
export { ForwardRef as ReactComponent };